import React from "react"
import autobind from "class-autobind"
import AppStateStore from "../../../stores/AppStateStore"
import AccountStore from "../../../stores/AccountStore"
import strings from "../../../localization/strings"
import moment from "moment"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import { EExceptionType, IPayrollPayCalendar, IUserFilter } from "../../../models"
import * as reportAction from "../../../actions/ReportAction"
import * as payrollHelper from "../../../helpers/payrollHelper"

interface IProps {
    selectedPayrollPayCalendar: IPayrollPayCalendar
    userFilter: IUserFilter
    filterByDefaultHierarchy: boolean
    filterDirectReportsOnly: boolean
    filterByPunchHierarchy: boolean
    filterByException: boolean
    filterExceptions: EExceptionType[]
    handleClose(): void
}
interface IState {

}
export default class InOutReport extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {

        }
        autobind(this)
    }

    componentDidMount() {
        AppStateStore.setConfirmDialogContent({
            title: strings.In_Out_Report,
            content: strings.Are_you_sure_you_want_to_download_the_In_Out_Report,
            confirm: this.handleDownload
        })
    }

    handleDownload() {
        this.props.handleClose()
        reportAction.downloadInOutReport(AccountStore.getCurrentAccount().Id, HierarchySettingsStore.getGlobalLevelItemFilterId(), payrollHelper.getPayGroupIdsByPayrollPayCalendar(this.props.selectedPayrollPayCalendar), this.props.userFilter, moment().utc(true).format(), this.props.filterDirectReportsOnly, this.props.filterByDefaultHierarchy, this.props.filterByPunchHierarchy, this.props.filterByException, this.props.filterExceptions)
    }

    render() {
        return (
            <div />
        )
    }
}